import { classNames } from 'primereact/utils';
import { useBundleFilterChips } from '@/ui/pages/BundlePage/hooks';
import { Badge, Button, Chip } from '@repo/atomic-components';

export const FilterChips = () => {
  const { chipsList, handleClearAll } = useBundleFilterChips();

  return (
    !!chipsList.length && (
      <div className="bg-fletchers-green-500 flex flex-wrap items-center justify-center gap-1.5 border-none px-6 py-[8px]">
        <div className="flex items-center gap-1.5">
          <span className="text-[14px] text-white">Filters applied</span>
          <Badge
            value={chipsList.length}
            severity="warning"
            className="!flex !items-center !justify-center !text-[12px] !font-normal"
          />
          <span className="text-[14px] text-white">:</span>
        </div>

        {chipsList.map((item) => (
          <Chip
            label={item.label}
            key={item.key}
            removable
            onRemove={item.onRemove}
            pt={{
              root: {
                className: 'bg-fletchers-green-400 border-0 px-2 h-[24px] gap-[8px] hover:bg-fletchers-green-400/80',
              },
              label: { className: 'text-[14px] text-white [&]:first-letter:uppercase' },
              removeIcon: {
                className:
                  'rounded-xs !fill-white !text-white !color-white outline focus-visible:outline-white [&>path]:!fill-white',
              },
            }}
          />
        ))}

        <Button
          outlined
          label="Clear all"
          onClick={handleClearAll}
          pt={{
            root: {
              className: classNames(
                'px-1.75 h-[24px] border-0 hover:bg-fletchers-green-400/80',
                'focus-visible:outline focus-visible:outline-offset-1 focus-visible:outline-white',
              ),
            },
            label: { className: 'text-[14px] text-white font-semibold' },
          }}
        />
      </div>
    )
  );
};
